import { render, staticRenderFns } from "./Gap.vue?vue&type=template&id=b7813fce&"
import script from "./Gap.vue?vue&type=script&lang=ts&"
export * from "./Gap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports